import image from 'assets/images/device/price/image.png';
import DeviceImage from './DeviceImage';

const Price = () => {
  return (
    <div id={'device-price'}>
      <DeviceImage src={image} left={27} top={24} width={375} height={824} />
    </div>
  );
};

export default Price;
